export default "__VITE_ASSET__BFbYfT9o__"